/**
 * Vendor Rating Services
 * Services for vendor rating management operations
 */
// Export all service classes
export { VendorRatingService } from './VendorRatingService';
export { VendorRaterTypeService } from './VendorRaterTypeService';
export { VendorFlagTypeService } from './VendorFlagTypeService';
export { VendorFlagStatusService } from './VendorFlagStatusService';
export { VendorFlagService } from './VendorFlagService';
export { VendorResponseService } from './VendorResponseService';
export { VendorRatingShopService } from './VendorRatingShopService';
// Import for factory function
import { VendorRatingService } from './VendorRatingService';
import { VendorRaterTypeService } from './VendorRaterTypeService';
import { VendorFlagTypeService } from './VendorFlagTypeService';
import { VendorFlagStatusService } from './VendorFlagStatusService';
import { VendorFlagService } from './VendorFlagService';
import { VendorResponseService } from './VendorResponseService';
import { VendorRatingShopService } from './VendorRatingShopService';
/**
 * Create all vendor rating services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all vendor rating services
 */
export function createVendorRatingServices(http, config) {
    return {
        vendorRating: new VendorRatingService(http, config),
        vendorRaterType: new VendorRaterTypeService(http, config),
        vendorFlagType: new VendorFlagTypeService(http, config),
        vendorFlagStatus: new VendorFlagStatusService(http, config),
        vendorFlag: new VendorFlagService(http, config),
        vendorResponse: new VendorResponseService(http, config),
        vendorRatingShop: new VendorRatingShopService(http, config),
    };
}
//# sourceMappingURL=index.js.map